module.exports = __webpack_public_path__ + "static/img/psyduck.d489a07e.png";